import { DateTime } from 'luxon'

export default class DateReservation {
  static PERIODS = [
    {label: '1 dia', value: 0},
    {label: 'Personalizado', value: -2}
  ]

  static getPeriod = reservation => {
    const period = DateTime.fromISO (reservation.end_date)
      .diff (DateTime.fromISO (reservation.start_date), ['days', 'months']).toObject ()

    const label = period.days === 0 ? '1 dia' : 'Personalizado'
    const value = period.days === 0 ? period.days : -2

    return { label, value }
  }

  static handlePeriodChange = (name, option, values, setFieldValue) => {
    const startDate = DateTime.fromISO (values.startDate)
    const interval = option.value === -2 ? null : {days: option.value}

    if (interval) {
      setFieldValue ('endDate', startDate.plus (interval).toISODate ())
    } else if (startDate) {
      setFieldValue ('endDate', startDate.plus ({days: 1}).toISODate ())
    }

    setFieldValue (name, option)
  }

  /**
   * Ajusta a data final quando a data inicial muda, preservando o período escolhido.
   *
   * Mover uma reserva de 1 dia de 10/08 para 20/08 deixava a data final em 10/08: a
   * validação barrava o envio e, como o campo de data final só aparece no período
   * personalizado, não havia como corrigir pelo formulário.
   *
   * @param startDate - A nova data inicial, em ISO.
   * @param values - Os valores atuais do formulário.
   * @param setFieldValue - O setter de campo do Formik.
   */
  static handleStartDateChange = (startDate, values, setFieldValue) => {
    setFieldValue ('startDate', startDate)

    const newStartDate = DateTime.fromISO (startDate)

    if (!newStartDate.isValid) return

    const setEndDate = days => setFieldValue (
      'endDate', newStartDate.plus ({ days }).toISODate ()
    )

    // Fora do período personalizado (-2), a duração está no próprio valor do período
    if (values.period?.value !== -2) return setEndDate (Math.max (values.period?.value ?? 0, 0))

    const previousStartDate = DateTime.fromISO (values.startDate)
    const previousEndDate = DateTime.fromISO (values.endDate)

    if (!previousStartDate.isValid || !previousEndDate.isValid) return setEndDate (0)

    setEndDate (Math.max (previousEndDate.diff (previousStartDate, 'days').days, 0))
  }
}
